import { Select, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import { Gender, ResourceFilterOptions } from '@/models';

type ResourceFilterProps = {
  filterOptions?: ResourceFilterOptions;
  filterValues?: {
    locations?: string[];
    genders?: Gender[];
    includeLanguages?: string[];
    states?: string[];
    cities?: string[];
    archived?: boolean;
  };
  onFilterChange?: (key: string, value: string[] | Gender[] | boolean | undefined) => void;
};

export const ResourceFilter = ({
  filterOptions,
  filterValues,
  onFilterChange,
}: ResourceFilterProps) => {
  const { t } = useTranslation();

  return (
    <Space wrap size='middle' style={{ marginBottom: 16 }}>
      <Select
        placeholder={t('common:locations')}
        value={filterValues?.locations || []}
        onChange={(value) => onFilterChange?.('locations', value?.length > 0 ? value : undefined)}
        allowClear
        showSearch={{
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
          optionFilterProp: 'children',
        }}
        mode='multiple'
        style={{ width: 200 }}
        options={filterOptions?.locations.values.map((location) => ({
          value: location.value,
          label: location.label,
        }))}
      />
      <Select
        placeholder={t('common:gender')}
        value={filterValues?.genders || []}
        onChange={(value) => onFilterChange?.('genders', value?.length > 0 ? value : undefined)}
        allowClear
        showSearch={{
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
          optionFilterProp: 'children',
        }}
        mode='multiple'
        style={{ width: 200 }}
        options={filterOptions?.genders.values.map((gender) => ({
          value: gender.value,
          label: t(`common:${gender.value.toLocaleLowerCase()}`),
        }))}
      />
      <Select
        placeholder={t('common:language')}
        value={filterValues?.includeLanguages || []}
        onChange={(value) =>
          onFilterChange?.('includeLanguages', value?.length > 0 ? value : undefined)
        }
        allowClear
        showSearch={{
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
          optionFilterProp: 'children',
        }}
        mode='multiple'
        style={{ width: 200 }}
        options={filterOptions?.includeLanguages.values.map((language) => ({
          value: language.value,
          label: language.label,
        }))}
      />
      <Select
        placeholder={t('common:states')}
        value={filterValues?.states || []}
        onChange={(value) => onFilterChange?.('states', value?.length > 0 ? value : undefined)}
        allowClear
        showSearch={{
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
          optionFilterProp: 'children',
        }}
        mode='multiple'
        style={{ width: 200 }}
        options={filterOptions?.states.values.map((state) => ({
          value: state.value,
          label: state.label,
        }))}
      />
      <Select
        placeholder={t('common:cities')}
        value={filterValues?.cities || []}
        onChange={(value) => onFilterChange?.('cities', value?.length > 0 ? value : undefined)}
        allowClear
        showSearch={{
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
          optionFilterProp: 'children',
        }}
        mode='multiple'
        style={{ width: 200 }}
        options={filterOptions?.cities.values.map((city) => ({
          value: city.value,
          label: city.label,
        }))}
      />
      <Select
        placeholder={t('common:archived')}
        value={filterValues?.archived}
        onChange={(value) => onFilterChange?.('archived', value)}
        allowClear
        showSearch={{
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
          optionFilterProp: 'children',
        }}
        style={{ width: 200 }}
        options={filterOptions?.archived.values.map((archived) => ({
          value: archived,
          label: archived ? t('common:archived') : t('common:active'),
        }))}
      />
    </Space>
  );
};
